<div style="float: right;" class="printPageButton">
  <mat-form-field appearance="outline">
    <mat-label>{{'SelectLanguage' | translate }}</mat-label>
    <mat-select  [(ngModel)]="selectedlang"  (selectionChange)="switchLang()" >
      <mat-option *ngFor="let language of translate.getLangs()"
       [value]="language">{{ language }}</mat-option>
    </mat-select>
  </mat-form-field>
  <button mat-raised-button color="primary" style="margin-left: 15px;" (click)="upadtelanguage()">Update</button>   
</div>
   


